@if(spinner.loading$ | async){
    <div class="overlay">
        <p-progressSpinner strokeWidth="2" animationDuration=".5s"></p-progressSpinner>
    </div>
}